import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Spinner.scss';

const ns = 'spinner';

const Spinner = ({ className, classNameCircle }) => {
  const classProps = classNames(ns, className);
  const classPropsCircle = classNames('path', classNameCircle);
  return (
    <svg
      className={classProps}
      width="60px"
      height="60px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={classPropsCircle}
        fill="none"
        strokeWidth="6"
        strokeLinecap={'round'}
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
  );
};

Spinner.propTypes = {
  className: PropTypes.string,
  classNameCircle: PropTypes.string
};

Spinner.defaultProps = {
  className: ns
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/atoms/Spinner/Spinner.js